import { gql } from '@apollo/client';

export const READ_AVAILABLE_POSITION = gql`
  query readAvailablePosition($input: AvailablePositionInput!) {
    readAvailablePosition(input: $input) {
      position
    }
  }
`;
